class CardFan extends HTMLElement {
  connectedCallback() {
    this.cards = Array.from(this.querySelectorAll('.card-fan__item'));
    this.stage = this.querySelector('.card-fan__stage');
    this.caption = this.querySelector('.card-fan__caption');
    this.activeIndex = 0;

    this.pointerId = null;
    this.pointerStartX = 0;
    this.pointerStartY = 0;
    this.downCard = null;
    this.swipeThreshold = 30;

    if (this.stage) {
      this.stage.addEventListener('pointerdown', this.onPointerDown.bind(this));
      this.stage.addEventListener('pointerup', this.onPointerUp.bind(this));
      this.stage.addEventListener('pointercancel', this.onPointerCancel.bind(this));
    }

    this.render();
  }

  onPointerDown(event) {
    if (event.button !== undefined && event.button !== 0) return;
    this.pointerId = event.pointerId;
    this.pointerStartX = event.clientX;
    this.pointerStartY = event.clientY;
    // Captured here, before pointer capture kicks in and redirects event.target
    // on subsequent events (pointerup would otherwise always report the stage).
    this.downCard = event.target.closest('.card-fan__item');
    if (this.stage.setPointerCapture) {
      try {
        this.stage.setPointerCapture(event.pointerId);
      } catch (e) {
        /* ignore */
      }
    }
  }

  onPointerUp(event) {
    if (this.pointerId === null || this.pointerId !== event.pointerId) return;

    const deltaX = event.clientX - this.pointerStartX;
    const deltaY = event.clientY - this.pointerStartY;

    if (Math.abs(deltaX) > this.swipeThreshold && Math.abs(deltaX) > Math.abs(deltaY)) {
      if (deltaX < 0) {
        this.next();
      } else {
        this.prev();
      }
    } else if (this.downCard) {
      const index = this.cards.indexOf(this.downCard);
      if (index > -1) this.setActive(index);
    }

    this.pointerId = null;
    this.downCard = null;
  }

  onPointerCancel() {
    this.pointerId = null;
  }

  next() {
    const total = this.cards.length;
    this.setActive((this.activeIndex + 1) % total);
  }

  prev() {
    const total = this.cards.length;
    this.setActive((this.activeIndex - 1 + total) % total);
  }

  setActive(index) {
    if (index === this.activeIndex) return;
    this.activeIndex = index;
    this.render();
  }

  render() {
    const total = this.cards.length;

    this.cards.forEach((card, index) => {
      let offset = index - this.activeIndex;
      if (offset > total / 2) offset -= total;
      if (offset < -total / 2) offset += total;

      const abs = Math.abs(offset);
      const translateX = offset * 78;
      const translateY = abs * 16;
      const rotate = offset * 10;
      const scale = Math.max(1 - abs * 0.14, 0.55);
      const opacity = Math.max(1 - abs * 0.32, 0);
      const z = 100 - abs;

      card.style.transform = `translate(${translateX}px, ${translateY}px) rotate(${rotate}deg) scale(${scale})`;
      card.style.opacity = String(opacity);
      card.style.zIndex = String(z);
      card.style.pointerEvents = opacity < 0.08 ? 'none' : 'auto';
      card.classList.toggle('is-active', offset === 0);
      card.setAttribute('aria-current', offset === 0 ? 'true' : 'false');
    });

    if (this.caption) {
      const activeLabel = this.cards[this.activeIndex]?.dataset.label || '';
      this.caption.textContent = activeLabel;
      this.caption.hidden = activeLabel === '';
    }
  }
}

customElements.define('card-fan', CardFan);
